import React from "react"
import { DatoContentBaseProps } from "../../types"
import TextBlock from "@components/TextBlock"

interface DatoCmsComponentTextBlockProps extends DatoContentBaseProps {}

const DatoCmsComponentTextBlock: React.FC<DatoCmsComponentTextBlockProps> = ({
  header,
  render,
  body,
  centerHeader,
  centerBody,
}) => {
  return (
    <TextBlock
      header={header}
      body={body}
      render={render}
      centerHeader={centerHeader}
      centerBody={centerBody}
    />
  )
}

export default DatoCmsComponentTextBlock
